import { createZustandStoreAndContext } from '@opengov/react-state-management';
import { transport } from '@opengov/transport';

import { FEDERATED_SERVICEIDS_TYPE, IAppSwitcherProducts, IProductDetails } from '../types';

import { getAuthToken, IAuth0Config } from '../auth0CredentialsProvider/auth0CredentialProvider';
export interface IEntityBase {
  id: string;
  name: string;
  state: string;
  country: string;
  subdomain: string;
  display_name: string;
}

export interface IAppSwitcherState {
  entity: IEntityBase;
  products: IAppSwitcherProducts;
  setEntity(entity: IEntityBase): void;
  getEntityAndProducts(
    federatedServiceType: FEDERATED_SERVICEIDS_TYPE,
    federatedId: string,
    baseUrl: string,
    auth0config?: IAuth0Config
  ): Promise<void>;
  getProductsWithoutAccess(): IProductDetails[];
  setEntityAndProducts(products: IAppSwitcherProducts): void;
}
export const [useAppSwitcherStore, AppSwitcherContext, cloneAppSwitcherStore] =
  createZustandStoreAndContext<IAppSwitcherState>((set, get) => ({
    entity: null,
    products: {
      entitled: [],
      unentitled: []
    },
    getEntityAndProducts: async (federatedServiceType, federatedId, baseUrl, auth0config: IAuth0Config) => {
      const query = `query($queryAction: Action, $queryValue: String) {
        queryEntity(queryAction: $queryAction,queryValue:$queryValue ) {
          id,
          name,
          appSwitcherProducts {
            entitled {
              entitlementProductKey,
              url,
              description,
              displayName,
              openInNewTab
            },
            unentitled {
              entitlementProductKey,
              url,
              displayName,
              openInNewTab
            }
          }
        }
      }`;

      const baseQueryEntityTransport = transport
        .url(`${baseUrl}/api/entity/v1/graphql`)
        .options({ credentials: 'include', mode: 'cors' })
        .json({ query, variables: { queryAction: federatedServiceType, queryValue: federatedId } });

      if (auth0config) {
        return getAuthToken(auth0config)
          .then(async (token) => {
            return baseQueryEntityTransport
              .auth(`Bearer ${token}`)
              .post()
              .json((res) => {
                set({ products: res?.data?.queryEntity?.appSwitcherProducts });
              });
          })
          .catch((error) => {
            // Do nothing
          });
      } else {
        return baseQueryEntityTransport.post().json((res) => {
          set({ products: res?.data?.queryEntity?.appSwitcherProducts });
        });
      }
    },
    getProductsWithoutAccess: () => {
      return get().products?.unentitled;
    },
    setEntity: (entity) => set({ entity: entity }),
    setEntityAndProducts: (products) => set({ products: products })
  }));
